import BindSaSuccessVue from '@/views/member/bind-sa/bind-sa.vue';

const basePath = '/member/bind-sa';
const role = 'member'; // 角色身份

export const M_BIND_SA_INDEX = 'm-bind-sa-index';
export const M_BIND_SA_SUCCESS = 'm-bind-sa-success';

export default {
  path: `${basePath}*`,
  redirect: `${basePath}/index`,
  component: BindSaSuccessVue,
  meta: { requiresAuth: true },
  children: [
    {
      path: `${basePath}/index`,
      name: M_BIND_SA_INDEX,
      props: true,
      component: () => import(
        /* webpackChunkName: "bind-sa-index" */
        `@/views/${role}/bind-sa/index.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    },
    {
      path: `${basePath}/success`,
      name: M_BIND_SA_SUCCESS,
      component: () => import(
        /* webpackChunkName: "bind-sa-success" */
        `@/views/${role}/bind-sa/success.vue`
      ).catch(() => import('@/views/errors/404.vue')),
      meta: { requiresAuth: true }
    }
  ]
};
